// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"77ecb64d","58":"b00e3c61","351":"8b85e4ef","453":"bb49e054","612":"078149d6","649":"b960495d","716":"a95c26da","903":"5482c05b","925":"347c68b3","990":"8a957228"}[chunkId] + ".chunk.js";
};